import Avatar from "@material-ui/core/Avatar";
import Person from "@material-ui/icons/Person";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import React, {useContext, useEffect, useRef, useState} from "react";
import SecurityContext from "../../../SecurityContext";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Box from '@material-ui/core/Box';
import {makeStyles} from "@material-ui/core/styles";

import "./userinfo.css";

const useStyles = makeStyles(theme => ({
    userInfo: {
        width: '300px',
        height: '100%',
        background: '#778899',
        marginLeft: '24px',
        display: 'flex',
        alignItems: 'center',
    },
    avatar: {
        width: '40px',
        height: '40px',
        borderRadius: '20px',
        marginLeft: '24px',
    },
    avatarActive: {
        width: '40px',
        height: '40px',
        borderRadius: '20px',
        marginLeft: '24px',
        cursor: 'pointer'
    },
    userData: {
        width: '155px',
        marginLeft: '16px',
        maxWidth: '155px',
    },
    userName: {
        fontWeight: '600',
        marginBottom: '5px',
    },
    userOrg: {
        marginTop: '5px',
        fontSize: '12px',
        fontWeight: '400',
        display: 'inline-block',
         width: 160,
         whiteSpace: 'nowrap',
         cursor: 'pointer',
         '& .MuiBox-root': {
           marginTop: 0,
           marginBottom: 0
         }
    },
    divider: {
        width: '1px',
        height: '30px',
        margin: '0 9px 0 22px',
        background: '#DADADA',
    },
    fileInput: {
        display: 'none'
    }
}));


export default function UserInfo({me, loadMe, setAvatar}) {
    useEffect(() => {
        loadMe();
    }, [loadMe]);


    const {
        userInfo, avatar, avatarActive,
        userData, userName, userOrg, ellipsisMultiline,
        divider, fileInput
    } = useStyles();
    let security = useContext(SecurityContext);
    let [meMenuEl, setMeMenuEl] = useState(null);
    let [orgMenuEl, setOrgMenuEl] = useState(null);

    //let ContextOrg = JSON.parse(Cookies.get('COPP_ContextOrg'));
    //let orgList = [{id: 1, name: "Длинное придлиннное название организации"},{id: 2, name: "Организация 2"}];
    let orgList = [];
    let ContextOrg = orgList && orgList.length > 0 ? orgList[0] : {};


    let meName = 'Неизвестный пользователь';
    let meAvatar = null;
    if (me) {
        meName = me.lastName || '';
        if (me.firstName) {
            meName += ' ' + me.firstName.substr(0, 1) + '.';
        }
        if (me.middleName) {
            meName += ' ' + me.middleName.substr(0, 1) + '.';
        }
        if (me.avatar) {
            meAvatar = '/work/api/file/' + me.avatar;
        }
    }


    let meInfoRef = useRef();
    let orgInfoRef = useRef();
    let editIconRef = useRef();

    const handleClick = event => {
        setMeMenuEl(meInfoRef.current);
    };

    const handleClose = () => {
        setMeMenuEl(null);
    };

    const handleProfileClick = () => {
        setMeMenuEl(null);
        window.location.href = process.env.REACT_APP_KEYCLOAK_BASE_URI + '/realms/copp-work/account';
    };
    const handleAvatarChangeClick = () => {
        setMeMenuEl(null);
        if (editIconRef.current) {
            editIconRef.current.click();
        }
    };

    const handleAvatarLoad = (e) => {
        setMeMenuEl(null);
        if (e.target.files.length > 0) {
            setAvatar(e.target.files[0]);
        }
    };

    const handleOrgClick = (event) => {
      setOrgMenuEl(event.currentTarget);
    };

    const handleOrgClose = () => {
        setOrgMenuEl(null);
    };

    const handleOrgListClick = (id, name) => {
        setOrgMenuEl(null);
        //const cookies = new Cookies();
        //cookies.set('COPP_ContextOrg', value);
    };

    return (
        <div ref={meInfoRef} className={userInfo}>
            <input ref={editIconRef} className={fileInput}
                   onChange={handleAvatarLoad}
                   accept="image/*" type="file"/>
            {me ?
                <>
                    <Avatar onClick={handleClick} className={avatarActive} src={meAvatar}>
                        <Person/>
                    </Avatar>
                    <Menu
                        elevation={0}
                        anchorEl={meMenuEl}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        keepMounted
                        open={Boolean(meMenuEl)}
                        onClose={handleClose}>
                        <MenuItem onClick={handleProfileClick}>Профиль</MenuItem>
                        <MenuItem onClick={handleAvatarChangeClick}>Изменить аватар</MenuItem>
                    </Menu>
                </>
                :
                <Avatar className={avatar}>
                    <Person/>
                </Avatar>
            }

            <div className={userData}>
                <div className={userName}>{meName}</div>
                {orgList && orgList.length > 0 &&
                  <div>
                  {orgList.length > 1
                    ? <>
                    <div className={userOrg}>
                      <Box
                        component="div"
                        my={2}
                        textOverflow="ellipsis"
                        overflow="hidden"
                        bgcolor="#778899"
                        onClick={handleOrgClick}>
                        {ContextOrg.name}
                      </Box>
                    </div>
                        <Menu
                            id="org-list-menu"
                            anchorEl={orgMenuEl}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            keepMounted
                            open={Boolean(orgMenuEl)}
                            onClose={handleOrgClose}>
                            {orgList.map(({id, name}) =>
                              <MenuItem onClick={() => handleOrgListClick(id, name)}>{name}</MenuItem>
                            )}
                        </Menu>
                      </>
                    : <div className={userOrg}>
                      <Box
                        component="div"
                        my={2}
                        textOverflow="ellipsis"
                        overflow="hidden"
                        bgcolor="#778899">
                        {ContextOrg.name}
                      </Box>
                    </div>
                  }
                  </div>
                }
            </div>
            <div className={divider}/>
            <PowerSettingsNewIcon cursor="pointer" fontSize="default"
                                  onClick={() => security.logout()}/>
        </div>
    )

}
